import axios, { AxiosRequestConfig } from 'axios'
import { getDeviceFingerprint } from './deviceFingerprint'

/** Header key carrying the device fingerprint on every request. */
export const DEVICE_HEADER_KEY = 'x-kp'

/**
 * Attaches the device fingerprint as the x-kp header to a request config,
 * creating the headers object when absent. Shared by the apiClient interceptor
 * and the global default-axios interceptor so both surfaces stay in sync.
 *
 * The value is read per-request (not captured at startup) so clearing
 * localStorage mid-session regenerates the id instead of replaying a stale one.
 */
export const attachDeviceHeader = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers = config.headers || {}
  config.headers[DEVICE_HEADER_KEY] = getDeviceFingerprint()
  return config
}

/**
 * Registers the x-kp interceptor on the default axios instance so the raw
 * axios.* calls (login, lead fetch, CSV upload, token checks) carry the header.
 * apiClient is a separate instance and sets the header in its own interceptor.
 *
 * Call once at app startup, before any request fires.
 */
export const registerGlobalDeviceHeader = (): void => {
  axios.interceptors.request.use(attachDeviceHeader)
}